export function isWeChatAuthEnabled(): boolean {
  return import.meta.env.VITE_WECHAT_AUTH_ENABLED === 'true'
}
